// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page-header--2n_E-{align-items:center;background:#333;box-sizing:border-box;color:#fff;display:flex;font-size:32px;margin-bottom:30px;min-height:120px;padding:80px 30px 30px;transition:0.3s padding}.page-header-github--3NX0V{margin:30px;position:absolute;right:0;top:0}.page-header-github--3NX0V path{fill:#fff}@media only screen and (min-width: 768px) and (min-device-width: 768px){.page-header--2n_E-{padding:30px 90px 30px 30px}}\n", ""]);
// Exports
exports.locals = {
	"page-header": "page-header--2n_E-",
	"page-header-github": "page-header-github--3NX0V"
};
module.exports = exports;
